export default __webpack_public_path__ + "static/media/20945183.dd7df65f.jpg";